exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".badge {\n  width: 100% !important;\n  padding: 5px;\n}\n\n#trip-overview-table {\n  font-size: 12px;\n  padding: 0px;\n}", ""]);

